import { FC } from 'react';
import { DsoModal } from 'components/DSO/DsoModal';
import { Button } from 'components/core';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { DSOConfirmModalProps, Styled } from './';
import { useI18n } from 'contexts/i18n';

const DSOConfirmModal: FC<DSOConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = '',
  description = '',
  buttonGoBackText = 'Go Back',
  buttonConfirmText = 'Yes, proceed',
  iconSize = 64,
  isLoading = false,
  loadingText,
  ...rest
}) => {
  const i18n = useI18n();
  return (
    <DsoModal
      isOpen={isOpen}
      centered
      size="md"
      dismissOnOverlayClick={false}
      isLoading={isLoading}
      loadingText={loadingText}
      {...rest}
      footer={
        <Styled.FooterWrapper>
          <Button
            variant="secondary"
            size="lg"
            width="150px"
            onClick={onClose}
            testId="confirm-modal-go-back-btn"
          >
            {buttonGoBackText === 'Go Back'
              ? i18n['Go Back']
              : buttonGoBackText}
          </Button>
          <Button
            variant="primary"
            size="lg"
            width="150px"
            onClick={onConfirm}
            testId="confirm-modal-confirm-btn"
          >
            {buttonConfirmText === 'Yes, proceed'
              ? i18n['Yes, proceed']
              : buttonConfirmText}
          </Button>
        </Styled.FooterWrapper>
      }
    >
      <Styled.ConfirmModalBody data-testid="confirm-modal-body">
        <Styled.ConfirmModalIcon data-testid="confirm-modal-icon">
          <AiOutlineInfoCircle size={iconSize} />
        </Styled.ConfirmModalIcon>
        <Styled.ConfirmModalTitle data-testid="confirm-modal-title">
          {title}
        </Styled.ConfirmModalTitle>
        <Styled.ConfirmModalDescription data-testid="confirm-modal-description">
          {description}
        </Styled.ConfirmModalDescription>
      </Styled.ConfirmModalBody>
    </DsoModal>
  );
};
export default DSOConfirmModal;
